<template>
	<h1 class="base-h1" :class="[`text-${color}`]">
		<slot></slot>
	</h1>
</template>
<script>
import { BaseMixin } from '@/mixins'

export default {
	name: 'BaseH1',
	mixins: [BaseMixin],
}
</script>
<style lang="scss">
.base-h1 {
	font-size: 30px;
	font-weight: bold;
	line-height: 40px;
	font-family: 'Acumin Pro', sans-serif;
}
</style>
